"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaloEffectHandler = exports.HaloEffectArgs = void 0;
const _1 = require(".");
const __1 = require("../../..");
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class HaloEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Halo;
        this.__typeName = "Halo";
        this.name = "Halo";
        this.harmful = false;
    }
}
exports.HaloEffectArgs = HaloEffectArgs;
let HaloEffectHandler = class HaloEffectHandler {
    apply(sequence, container, state) {
        state.meta.increaseAgilityEffectId = container.applyBuff({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            effect: new _1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Focus, container.getPercentOfBaseAttributeScore(state.targetId, 10, "Focus")),
            duration: Duration_1.Duration.Permanent,
            supernatural: true
        });
        const scriptArgs = {
            chancePercent: 100,
            effect: new _1.SlowEffectArgs(1),
            effectDuration: Duration_1.Duration.Turns(4)
        };
        state.meta.eventHandlerId = container.registerEventHandler(state.creatorId, EventType_1.EventType.Attack, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_EffectOnHit_OnAttack", scriptArgs));
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.increaseAgilityEffectId);
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
HaloEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Halo)
], HaloEffectHandler);
exports.HaloEffectHandler = HaloEffectHandler;
